import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Message from './Message.js';
import Api from "../../Api.js";


const MessageList = ({message,setMessage,task}) => {
    const [seeMoreSms, setSeeMoreSms] = useState(true);


    useEffect(() => {
        (async () => {

            if (task?.new_sms_count > 0) {
                await Api.seenMessage(task?.id)
                await fetchTaskSms(0);
            } else {
                await fetchTaskSms(0);
            }
        })()


    }, [task?.id]);

    const fetchTaskSms = async (startIndex) => {
        const {data} = await Api.getMessage(task?.id,{
            start_index: startIndex,
            for_all: null,
        })
        setMessage(prev => [...prev, ...data]);
        if(data.length === 0) {
            setSeeMoreSms(false);
        }

    };

    const handleScroll = async (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;

        if (scrollHeight - scrollTop <= clientHeight + 1) {
            if (message.length % 10 === 0) {
                await fetchTaskSms(message.length);
                console.log('Scrolled to bottom, fetching more...');
            }
        }
    };


    return (
        <div className="message-list" onScroll={handleScroll}>
            {message.map((item, index) => {
                const profession = localStorage.getItem('profession');
                const isMine = (profession === 'manager' && item.manager) || (profession === 'accountant' && item.accountant);
                return <Message key={index} data={item} isMine={isMine} />;
            })}
            {message.length % 10 === 0 && seeMoreSms && (
                <div className="see-more-sms" onClick={() => fetchTaskSms(message.length)}>
                    Տեսնել ավելին
                </div>
            )}
        </div>
    );
};

export default MessageList;
